import {
  LumenButton,
  LumenModal,
  LumenModalActions,
} from '@photoshelter/socialie-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router-dom';

interface Props {
  msg: string;
}

export default function ProtectUnsavedChanges({ msg }: Props) {
  const { t } = useTranslation();
  useEffect(() => {
    const preventUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', preventUnload);
    return () => {
      window.removeEventListener('beforeunload', preventUnload);
    };
  }, []);

  const blocker = useBlocker(true);

  return (
    <LumenModal
      isOpen={blocker.state === 'blocked'}
      title={t('protectUnsavedChanges.title')}
      onOpenChange={(isOpen) => {
        if (!isOpen && blocker) blocker.reset?.();
      }}
    >
      {msg}

      <LumenModalActions>
        <LumenButton
          color="secondary"
          onClick={() => {
            blocker.reset?.();
          }}
        >
          {t('global.cancel')}
        </LumenButton>
        <LumenButton
          color="primary"
          onClick={() => {
            blocker.proceed?.();
          }}
        >
          {t('global.continue')}
        </LumenButton>
      </LumenModalActions>
    </LumenModal>
  );
}
